"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getViewingPlatforms = void 0;
var _reactFeather = require("react-feather");
const PLATFORMS_ENDPOINT = process.env.REACT_APP_VIEWING_PLATFORMS;
const getViewingPlatforms = async _ref => {
  let {
    queryKey
  } = _ref;
  const [_key, {
    network,
    baseApiUrl
  }] = queryKey;
  const platformsEndpoint = PLATFORMS_ENDPOINT || baseApiUrl;
  try {
    const response = await fetch("".concat(platformsEndpoint, "/").concat(network));
    if (response !== null && response !== void 0 && response.ok) {
      const results = await response.json();
      let platforms = new Map();
      for (let i = 0; i < results.length; i++) {
        platforms.set(results[i].category, results[i].viewing_platforms.map((item, index) => {
          var _item$target;
          return {
            id: "".concat(results[i].category.slug, "-").concat(index),
            image_url: item !== null && item !== void 0 && item.override_image ? item.image_override : item.platform.image,
            alt_text: item.platform.name,
            link: item.link_url,
            target: (_item$target = item === null || item === void 0 ? void 0 : item.target) !== null && _item$target !== void 0 ? _item$target : '_blank'
          };
        }));
      }
      return platforms;
    } else {
      console.log("An error was returned from fetch. HTTP Response Code: ', ".concat(response === null || response === void 0 ? void 0 : response.status));
      return {
        error: {
          type: 'Fetch Response Error',
          statusCode: response === null || response === void 0 ? void 0 : response.status
        }
      };
    }
  } catch (error) {
    console.log('Fetch failed with error:', error);
    return {
      error: {
        type: 'Fetch Failed',
        message: error
      }
    };
  }
};
exports.getViewingPlatforms = getViewingPlatforms;